import {
    findParent,
    focus,
    KeyboardNavigator as IKeyboardNavigator,
    KeyKeyCodeMap,
    ResultAction,
} from '../common/keyboard.model';

export class KeyboardNavigator implements IKeyboardNavigator {
    private _lastFocused: HTMLElement;

    constructor(private readonly _root: HTMLElement) {}

    _handleEvent($event: KeyboardEvent): ResultAction {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const el = <HTMLElement>$event.target;
        if (!el) return ResultAction.IGNORE;

        if (
            $event.keyCode === KeyKeyCodeMap.ArrowLeft ||
            $event.keyCode === KeyKeyCodeMap.ArrowRight
        ) {
            return ResultAction.BOTH;
        }

        if (
            $event.keyCode === KeyKeyCodeMap.ArrowUp ||
            $event.keyCode === KeyKeyCodeMap.ArrowDown
        ) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unnecessary-type-assertion
            const els = <HTMLElement[]>(
                Array.from(
                    this._root.querySelectorAll(
                        '[role=tabpanel] .cmps-notification',
                    ),
                )
            );
            const index = els.indexOf(this._lastFocused || el);
            const goToPrevious = $event.keyCode === KeyKeyCodeMap.ArrowUp;
            const nextIndex = index + (goToPrevious ? -1 : 1);
            const finalIndex =
                nextIndex >= els.length
                    ? 0
                    : nextIndex < 0
                    ? els.length - 1
                    : nextIndex;
            const next = els[finalIndex];
            if (next) {
                els.forEach((el) => el.setAttribute('aria-selected', 'false'));
                next.setAttribute('aria-selected', 'true');
            }
            focus(els, next);
            this._lastFocused = next;
            return ResultAction.BOTH;
        }

        return ResultAction.IGNORE;
    }

    handleEvent($event: KeyboardEvent): void {
        const ret = this._handleEvent($event);
        switch (ret) {
            case ResultAction.NO_PROPAGATE:
                $event.stopPropagation();
                break;
            case ResultAction.NO_DEFAULT:
                $event.preventDefault();
                break;
            case ResultAction.BOTH:
                $event.stopPropagation();
                $event.preventDefault();
        }
    }

    select($event: MouseEvent): void {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const el = <HTMLElement>$event.target;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unnecessary-type-assertion
        const els = <HTMLElement[]>(
            Array.from(
                this._root.querySelectorAll(
                    '[role=tabpanel] .cmps-notification',
                ),
            )
        );
        const next = findParent(el, '.cmps-notification');
        if (next) {
            els.forEach((el) => el.setAttribute('aria-selected', 'false'));
            next.setAttribute('aria-selected', 'true');
        }
        focus(els, next);
        this._lastFocused = next;
    }
}
